import React from 'react';
import PropTypes from 'prop-types';
import { ButtonRound, Field, Icon } from '@ontruck/orc';
import { isEmpty } from 'utils/types';
import FieldError from 'components/form/FieldError';

import AddressSelector from 'components/form/AddressSelector';
import ResponsiveModal from 'components/ResponsiveModal';
import useFormState from 'hooks/useFormState';
import { useSelector } from 'react-redux';
import { selectors as shipmentSelectors } from 'state/shipments';

const StopAddress = ({
  placeholder,
  shipmentKey,
  stopType,
  responsiveModalRef,
  inputRef,
  inputModalRef,
  closeModal,
  inputValue,
  handleInputFocus,
  handleInputBlur,
  handleInputModalFocus,
  handleInputChange,
  address,
  className,
  id,
  error,
  warning,
  focused,
  handleClear,
  t,
}) => {
  const shipmentAddress = useSelector((state) =>
    shipmentSelectors.getShipmentAddress(state, shipmentKey, stopType)
  ).zipcode;

  const fieldType = `address`;
  const stopId = `${shipmentKey}-${stopType}`;
  const { fieldHasError } = useFormState(stopId, fieldType, shipmentAddress);

  const hasError = !!error || !!fieldHasError ? 'error' : 'not-error';

  return (
    <div className={className}>
      {address?.isZipcode && (
        <div className="floating-city-quote">{address.label}</div>
      )}
      {!!error && <FieldError className="error">{t(error)}</FieldError>}
      {!!warning && focused && (
        <FieldError className="error">{t(warning)}</FieldError>
      )}
      {/* Header is for mobile devices only */}
      <ResponsiveModal
        modalRef={responsiveModalRef}
        refProperty="fieldRef"
        inputRef={inputRef}
        disableModalOnMobile
        header={
          <Field
            type="text"
            className="stop-address__input"
            id={`${id}-modal`}
            name={id}
            fieldRef={inputModalRef}
            value={inputValue}
            placeholder={placeholder}
            label={placeholder}
            labelType="hidden"
            size="L"
            fullWidth
            onChange={handleInputChange}
            onFocus={handleInputModalFocus}
            invalid={!!warning}
            error={!!error}
            autoComplete="off"
            asideRightText={<Icon glyph="search" size="16px" color="grey500" />}
          />
        }
        content={
          <AddressSelector
            closeModal={closeModal}
            shipmentKey={shipmentKey}
            stopType={stopType}
            hasError={!!error}
            inputValue={inputValue}
          />
        }
      >
        <Field
          type="text"
          dataE2E={`${stopType}-stop-address`}
          className={`${hasError} stop-address__input`}
          id={id}
          name={id}
          value={inputValue}
          placeholder={placeholder}
          label={placeholder}
          labelType="hidden"
          size="L"
          fullWidth
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          invalid={!!warning}
          // error={!!error || fieldHasError}
          autoComplete="off"
          asideRightText={
            isEmpty(inputValue) && (
              <Icon glyph="search" size="16px" color="grey500" />
            )
          }
        />
      </ResponsiveModal>
      {!isEmpty(inputValue) && (
        <span className="icon">
          <ButtonRound
            skin="primary"
            size="XXS"
            icon="close"
            onClick={handleClear}
          />
        </span>
      )}
    </div>
  );
};

StopAddress.propTypes = {
  placeholder: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  stopType: PropTypes.string.isRequired,
  responsiveModalRef: PropTypes.func,
  inputRef: PropTypes.func,
  inputModalRef: PropTypes.func,
  closeModal: PropTypes.func,
  inputValue: PropTypes.string,
  handleInputFocus: PropTypes.func.isRequired,
  handleInputModalFocus: PropTypes.func.isRequired,
  handleInputBlur: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  address: PropTypes.shape({}),
  className: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.string,
  warning: PropTypes.string,
  focused: PropTypes.bool,
  t: PropTypes.func.isRequired,
  handleClear: PropTypes.func,
};

StopAddress.defaultProps = {
  placeholder: '',
  inputValue: '',
  responsiveModalRef: () => {},
  inputRef: () => {},
  inputModalRef: () => {},
  closeModal: () => {},
  address: null,
  className: '',
  id: '',
  error: '',
  warning: '',
  focused: false,
  handleClear: () => ({}),
};

export default StopAddress;
